module.exports = __webpack_public_path__ + "static/szymonMowiLogo-ba9d62f94c064578d9d3ed9f81060fa9.svg";